import { RefObject, useEffect } from 'react';

interface OutsideClickProps {
  refs: RefObject<HTMLElement>[];
  callback: () => void;
  enabled?: boolean;
}

export const useOutsideClick = ({ refs, callback, enabled = true }: OutsideClickProps) => {
  useEffect(() => {
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent) => {
      const is_outside = refs.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node)
      );
      if (is_outside) {
        callback();
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [refs, callback, enabled]);
};
